import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPageViewEvent implements GATrackingEvent {
  constructor() {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PageView;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PageView,
    };
  }
}
